import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind class names, letting later classes win over earlier ones.
 *
 * Without this, a caller passing `className="p-8"` to a component whose own
 * default is `p-6` produces `p-6 p-8` and the winner is decided by stylesheet
 * order rather than by the caller. `twMerge` resolves the conflict properly.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
